"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//

exports.default = {
  props: ["oldInput", "errors", "previousAction", "sessionParams"],

  mounted: function mounted() {
    this.$store.commit("addRequestErrors", {
      action: this.previousAction,
      data: {
        oldInput: this.oldInput,
        errors: this.errors,
        params: this.sessionParams
      }
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/general/RequestErrors.vue
// module id = GF0c
// module chunks = 0 1